import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["stringValue", "value"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { addDays, format, isValid, parse, subDays } from 'date-fns-new';
import { isEqalDate, isInInterval } from "../../utils/date";
export var dateFormat = 'dd.MM.yyyy';
export var dateRangeFormat = 'dd.MM.yyyy - dd.MM.yyyy';
export var monthFormat = 'MM/yy';
export var getPartDate = function getPartDate(formatArray, stringArray, marker) {
  var index = formatArray.indexOf(marker);
  if (index >= 0 && stringArray[index] && stringArray[index].length === marker.length) {
    return stringArray[index];
  }
  return undefined;
};
export var getParts = function getParts(formatStr) {
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '.';
  var withTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (withTime) {
    var _formatStr$split = formatStr.split(' '),
      _formatStr$split2 = _slicedToArray(_formatStr$split, 2),
      date = _formatStr$split2[0],
      time = _formatStr$split2[1];
    return [].concat(_toConsumableArray(date ? date.split(separator) : []), _toConsumableArray(time ? time.split(':') : []));
  }
  return formatStr.split(separator);
};
export var formatRangeDate = function formatRangeDate(dates) {
  return dates.map(function (el) {
    return el ? format(el, dateFormat) : '';
  }).join(' - ');
};
export var getDateFromString = function getDateFromString(str) {
  var formatArray = getParts(dateFormat, '.', true);
  var valueArray = getParts(str, '.', true);
  var validArray = formatArray.map(function (marker) {
    return getPartDate(formatArray, valueArray, marker);
  }).filter(function (item) {
    return Boolean(item);
  });
  if (formatArray.length === validArray.length) {
    return parse(valueArray.join('.'), formatArray.join('.'), new Date());
  }
  return null;
};
export var getMonthFromString = function getMonthFromString(str) {
  var formatArray = getParts(monthFormat, '/');
  var valueArray = getParts(str, '/');
  var validArray = formatArray.map(function (marker) {
    return getPartDate(formatArray, valueArray, marker);
  }).filter(function (item) {
    return Boolean(item);
  });
  if (formatArray.length === validArray.length) {
    return parse(valueArray.join('.'), formatArray.join('.'), new Date());
  }
  return null;
};
export var getValidSingleValue = function getValidSingleValue(date, minDate, maxDate, disableDates) {
  var analyzeDisabledDates = function analyzeDisabledDates(targetDate, disabledPeriods) {
    var disabledPeriod = disabledPeriods.find(function (el) {
      return Array.isArray(el) ? isInInterval(targetDate, el[0], el[1]) : isEqalDate(el, targetDate);
    });
    if (disabledPeriod) {
      var startPeriod = Array.isArray(disabledPeriod) ? disabledPeriod[0] : disabledPeriod;
      return minDate && minDate >= startPeriod ? addDays(Array.isArray(disabledPeriod) ? disabledPeriod[1] : disabledPeriod, 1) : subDays(startPeriod, 1);
    }
    return targetDate;
  };
  if (disableDates !== null && disableDates !== void 0 && disableDates.length) {
    var newDate = analyzeDisabledDates(date, disableDates);
    if (!isEqalDate(newDate, date)) {
      return newDate;
    }
  }
  if (minDate && date < minDate) {
    return disableDates ? analyzeDisabledDates(minDate, disableDates) : minDate;
  }
  if (maxDate && date > maxDate) {
    return disableDates ? analyzeDisabledDates(maxDate, disableDates) : maxDate;
  }
  return date;
};
var checkFirstPartOfRange = function checkFirstPartOfRange(_ref) {
  var stringValue = _ref.stringValue,
    minDate = _ref.minDate,
    maxDate = _ref.maxDate,
    disableDates = _ref.disableDates;
  if (stringValue) {
    var date = getDateFromString(stringValue);
    if (date) {
      return [getValidSingleValue(date, minDate, maxDate, disableDates), null];
    }
  }
  return false;
};
var checkFullStringOfRange = function checkFullStringOfRange(_ref2) {
  var stringValue = _ref2.stringValue,
    minDate = _ref2.minDate,
    maxDate = _ref2.maxDate,
    disableDates = _ref2.disableDates;
  var getSortedDate = function getSortedDate(stringRange) {
    var _split$map = (stringRange || '').split(' - ').map(function (el) {
        return el ? getDateFromString(el) : null;
      }),
      _split$map2 = _slicedToArray(_split$map, 2),
      start = _split$map2[0],
      end = _split$map2[1];
    return start && end && end < start ? [end, start] : [start, end];
  };
  var _getSortedDate = getSortedDate(stringValue),
    _getSortedDate2 = _slicedToArray(_getSortedDate, 2),
    start = _getSortedDate2[0],
    end = _getSortedDate2[1];
  if (start && end) {
    // Если начало периода не входит в интервал, подменяем старт крайним значением интервала
    if (!isInInterval(start, minDate, maxDate)) {
      if (minDate && minDate > start) {
        start = minDate;
      } else if (maxDate && maxDate < start) {
        start = maxDate;
      }
    }

    // Если конец периода не входит в интервал, подменяем конец крайним значением интервала
    if (!isInInterval(end, minDate, maxDate)) {
      if (minDate && minDate > end) {
        end = minDate;
      } else if (maxDate && maxDate < end) {
        end = maxDate;
      }
    }
    if (disableDates !== null && disableDates !== void 0 && disableDates.length) {
      var includedInDisabledRangePeriod = disableDates.find(function (el) {
        return Array.isArray(el) ? isInInterval(start, el[0], el[1]) && isInInterval(end, el[0], el[1]) : isInInterval(el, start, end);
      });
      if (includedInDisabledRangePeriod) {
        start = subDays(Array.isArray(includedInDisabledRangePeriod) ? includedInDisabledRangePeriod[0] : includedInDisabledRangePeriod, 1);
        end = null;
      }
    }
    return [start, end];
  }
  return false;
};
export var analyzeStringRangeValue = function analyzeStringRangeValue(_ref3) {
  var stringValue = _ref3.stringValue,
    value = _ref3.value,
    params = _objectWithoutProperties(_ref3, _excluded);
  // Если введено полностью начало периода, анализируем его
  if ((stringValue === null || stringValue === void 0 ? void 0 : stringValue.length) === dateFormat.length) {
    return checkFirstPartOfRange(_objectSpread({
      stringValue: stringValue
    }, params));
  }
  if (value && isValid(value) && formatRangeDate(value) === stringValue) {
    return false;
  }

  // Если период введен полностью, анализируем его
  if ((stringValue === null || stringValue === void 0 ? void 0 : stringValue.length) === dateRangeFormat.length) {
    return checkFullStringOfRange(_objectSpread({
      stringValue: stringValue
    }, params));
  }
  return false;
};